module.exports = __webpack_public_path__ + "static/media/compilación_solo.e18f4bc.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/compilación_solo.mp4
// module id = W3Q+
// module chunks = 0